import React from "react";
import hayk from '../assets/hayk.jpg';
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
        
        <div className="responsive-container-block textSide">
          <p className="text-blk heading">Mathematics Tutor at FutureMedsAcademy</p>
          {/* <h2>My Journey and the Vision Behind Future MedsAcademy</h2> */}
          <p className="text-blk subHeading">
          Hayk Sargsyan, a business student at LCC International University, brings his expertise in mathematics to the IMAT preparation journey. With extensive experience teaching key mathematical topics such as algebra, logarithms, and problem-solving techniques, Hayk has developed a straightforward and effective teaching style. His focus is on helping students grasp mathematical concepts with ease and confidence. Passionate about making math approachable for everyone, Hayk is dedicated to guiding IMAT aspirants through the exam's challenging math sections, ensuring they feel well-prepared to tackle any question that comes their way.
          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>

        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImg"
            src={hayk}
            alt="Main"
          />
                <h1>Hayk Sarsyan</h1>

        </div>
    
      </div>
    </div>
     );
    };
    
    export default AboutUs;